import Fetch from '@/utils/Fetch';
import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

const PeachPage: FC = () => {

    const router = useRouter();
    const { origin, isSettlement, isResubscription, firstName, lastName, emailAddress } = router.query as any; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const { data: paymentData } = useQuery(
        ['peach-checkout', origin, isSettlement, isResubscription, firstName, lastName, emailAddress],
        () => Fetch.post({
            url: `/Billing/PeachPaymentsCheckout`,
            params: {
                Origin: origin,
                IsSettlement: isSettlement?.toString().toLowerCase() === "true",
                IsResubscription: isResubscription?.toString().toLowerCase() === "true",
                FirstName: firstName,
                LastName: lastName,
                EmailAddress: emailAddress
            }
        }),
        { enabled: !!origin }
    );

    const url = paymentData?.Url;
    const checkoutKey = paymentData?.EntityID;
    const checkoutId = paymentData?.CheckoutID;

    useEffect(() => {

        if (!url || !checkoutKey || !checkoutId) return;

        const script = document.createElement('script');
        script.src = url;
        script.onload = () => {
            if ((window as any).Checkout) {
                const checkout = (window as any).Checkout.initiate({
                    key: checkoutKey,
                    checkoutId: checkoutId
                });
                checkout.render("#payment-form");
            }
        };
        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) document.body.removeChild(script);
        };

    }, [url, checkoutKey, checkoutId]);

    if (!router.isReady || !paymentData) return null;

    return (<>

        <div id="payment-form"></div>

        <style jsx>{`
            
            :global(body) {
                overflow-y: hidden;
            }

            #payment-form {
                max-width: 800px;
                margin: 0 auto;
                margin-top: 1rem;
                background-color: #fff;
                padding: 20px;
                border-radius: 5px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                height: calc(100vh - 2rem); /* Set a fixed height */
            }

            /* Media query for screens smaller than 768px (typical mobile screens) */
            @media (max-width: 1019px) {
                #payment-form {
                    width: 350px;
                    margin: 0 auto;
                    padding: 10px;
                }
            }

        `}</style>
    </>);
};

export default PeachPage;

export const Route = createFileRoute('/_authenticated/settings/subscription/peach')({ component: PeachPage })
